import type { Options } from 'markdown-it';
import markdownit from 'markdown-it';
import markdownItAttrs from 'markdown-it-attrs';
import type { MarkdownPlugin, MarkdownPluginOptions } from '../../types';

export default function rules({
	options = {},
	plugins = [],
	disabledExtensions = [],
}: {
	options?: Partial<Options & { disable?: string | string[] }>;
	plugins?: Array<MarkdownPlugin>;
	disabledExtensions?: Array<string>;
}) {
	const markdownIt = markdownit('default', {
		breaks: false,
		html: false,
		linkify: false,
		...options,
	});
	markdownIt.use(markdownItAttrs);
	plugins.forEach((plugin) =>
		markdownIt.use<MarkdownPluginOptions>(plugin, { disabledExtensions })
	);

	if (options.disable) {
		markdownIt.disable(options.disable, true);
	}

	return markdownIt;
}
